import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPartsLocationsDashboard = () => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/parts-dashboard/dashboard-parts-location',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PARTS_LOCATION_DASHBOARD,
      [
        {
          'type': ActionTypes.FETCHED_PARTS_LOCATION_DASHBOARD,
        },
      ],
      [
        ActionTypes.FETCHED_PARTS_LOCATION_DASHBOARD_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  }));
};
